export default "__VITE_PUBLIC_ASSET__7481ccec__"